module.exports = __webpack_public_path__ + "static/media/AnimalSlider.7d9a04b9.webp";